import Axios from "axios";

const actions = {
  hideGlobalToaster(store) {
    store.commit('setGlobalToaster', {
      show: false,
      message: '',
      variant: '',
      duration: 0,
    });
  },

  fetchAgencies(store) {
    return Axios.get('agencies')
        .then((response) => {
          store.commit('setAgencies', response.data);
        })
  },

  fetchCaseManagers(store) {
    return Axios.get('case-managers')
        .then((response) => {
          store.commit('setCaseManagers', response.data);
        })
  },

  isUserAdmin(store) {
    return (store.state.user.userSession.roles.indexOf('ROLE_ADMIN') !== -1);
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js